import PropTypes from 'prop-types';

import { formatDateToSpanish } from '../../../../utils/formatUtils';
import { Line } from '../../../../utils/globalPropTypes';

const ProgramPointTitle = ({ line, selectedDate }) => {
  const { day, month, year } = formatDateToSpanish(selectedDate);

  return (
    <div className="text-center modal-info mb-4">
      <div className="d-flex justify-content-center flex-wrap">
        <span>
          &quot;{line?.positionName} {line?.lineName}
          <br />
          Para el día {day?.text},{'  '}
          {day?.number} de {month} de {year}
        </span>
      </div>
    </div>
  );
};

ProgramPointTitle.propTypes = {
  line: Line.isRequired,
  selectedDate: PropTypes.string
};

ProgramPointTitle.defaultProps = {
  selectedDate: ''
};

export default ProgramPointTitle;
